import React, { createContext, useContext, useState, useCallback } from 'react';

const PageContextContext = createContext({
  currentPageContext: null,
  setPageContext: () => {},
  clearPageContext: () => {},
});

export const PageContextProvider = ({ children }) => {
  const [currentPageContext, setCurrentPageContext] = useState(null);

  const setPageContext = useCallback((context) => {
    setCurrentPageContext(context);
  }, []);

  const clearPageContext = useCallback(() => {
    setCurrentPageContext(null);
  }, []);

  return (
    <PageContextContext.Provider value={{ currentPageContext, setPageContext, clearPageContext }}>
      {children}
    </PageContextContext.Provider>
  );
};

export const usePageContext = () => {
  const context = useContext(PageContextContext);
  if (!context) {
    throw new Error('usePageContext must be used within a PageContextProvider');
  }
  return context;
};